var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 text-primary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-list" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("users_groups")) + "\n\t")
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("title"),
                error: _vm.$v.title.$error
              },
              on: { input: _vm.$v.title.$touch },
              model: {
                value: _vm.title,
                callback: function($$v) {
                  _vm.title = $$v
                },
                expression: "title"
              }
            })
          ],
          1
        )
      ]),
      _c("q-table", {
        ref: "table",
        staticClass: "q-mt-lg",
        attrs: {
          data: _vm.members,
          columns: _vm.columns,
          filter: _vm.filter_members,
          selection: "multiple",
          selected: _vm.selected,
          "row-key": "id",
          pagination: _vm.members_server_pagination,
          loading: _vm.loading,
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:selected": function($event) {
            _vm.selected = $event
          },
          "update:pagination": function($event) {
            _vm.members_server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("div", { staticClass: "col" }),
                _vm.reportsPermission
                  ? _c("q-btn", {
                      staticClass: "q-mr-sm",
                      attrs: {
                        color: "secondary",
                        icon: "fas fa-download",
                        label: _vm.$t("group_report")
                      },
                      on: {
                        click: function($event) {
                          return _vm.downloadReport()
                        }
                      }
                    })
                  : _vm._e(),
                _vm.selected.length > 0
                  ? _c("q-btn", {
                      staticClass: "q-mr-md",
                      attrs: {
                        color: "negative",
                        icon: "far fa-trash",
                        label: _vm.$t("remove")
                      },
                      on: {
                        click: function($event) {
                          _vm.confirm_remove = true
                        }
                      }
                    })
                  : _vm._e(),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "far fa-plus",
                    label: _vm.$t("add_members")
                  },
                  on: {
                    click: function($event) {
                      return _vm.addMembers()
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-th",
                    { attrs: { "auto-width": "" } },
                    [
                      _c("q-checkbox", {
                        attrs: { "indeterminate-value": "some" },
                        model: {
                          value: props.selected,
                          callback: function($$v) {
                            _vm.$set(props, "selected", $$v)
                          },
                          expression: "props.selected"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(props.cols, function(col) {
                    return _c(
                      "q-th",
                      { key: col.name, attrs: { props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t" + _vm._s(_vm.$t(col.label)) + "\n\t\t\t"
                        )
                      ]
                    )
                  })
                ],
                2
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c(
                  "q-tr",
                  { attrs: { props: props } },
                  [
                    _c(
                      "q-td",
                      { attrs: { "auto-width": "" } },
                      [
                        _c("q-checkbox", {
                          attrs: { color: "primary" },
                          model: {
                            value: props.selected,
                            callback: function($$v) {
                              _vm.$set(props, "selected", $$v)
                            },
                            expression: "props.selected"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      { key: "id", attrs: { "auto-width": "", props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" + _vm._s(props.row.id) + "\n\t\t\t\t"
                        )
                      ]
                    ),
                    _c("q-td", { key: "email", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(props.row.email) + "\n\t\t\t\t"
                      )
                    ]),
                    _c("q-td", { key: "full_name", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(props.row.full_name) +
                          "\n\t\t\t\t"
                      )
                    ]),
                    _c("q-td", { key: "document", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(props.row.document) +
                          "\n\t\t\t\t"
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "branches", attrs: { props: props } },
                      [
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              color: "primary",
                              "text-color": "white",
                              label: _vm.getQuantityBranches(
                                props.row.branches
                              ),
                              "no-ripple": ""
                            }
                          },
                          [
                            props.row.branches.length > 0
                              ? _c("q-tooltip", [
                                  _c(
                                    "p",
                                    { staticClass: "tooltip q-mb-sm" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.$t("branches")) +
                                          ":\n\t\t\t\t\t\t\t\t"
                                      ),
                                      _vm._l(props.row.branches, function(
                                        branch,
                                        index
                                      ) {
                                        return _c("span", { key: index }, [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(branch) +
                                              "\n\t\t\t\t\t\t\t\t\t"
                                          ),
                                          props.row.branches.length - 1 > index
                                            ? _c("span", [_vm._v(", ")])
                                            : _vm._e()
                                        ])
                                      })
                                    ],
                                    2
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      { key: "companies", attrs: { props: props } },
                      [
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              color: "primary",
                              "text-color": "white",
                              label: _vm.getQuantityCompanies(
                                props.row.companies
                              ),
                              "no-ripple": ""
                            }
                          },
                          [
                            props.row.companies.length > 0
                              ? _c("q-tooltip", [
                                  _c(
                                    "p",
                                    { staticClass: "tooltip q-mb-sm" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.$t("company")) +
                                          ":\n\t\t\t\t\t\t\t\t"
                                      ),
                                      _vm._l(props.row.companies, function(
                                        company,
                                        index
                                      ) {
                                        return _c("span", { key: index }, [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(company) +
                                              "\n\t\t\t\t\t\t\t\t\t"
                                          ),
                                          props.row.companies.length - 1 > index
                                            ? _c("span", [
                                                _vm._v(",\n\t\t\t\t\t\t\t\t\t")
                                              ])
                                            : _vm._e()
                                        ])
                                      })
                                    ],
                                    2
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("q-td", { key: "profile", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.getProfile(props.row.profile)) +
                          "\n\t\t\t\t"
                      )
                    ])
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_users_groups" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _vm.show_add_members
        ? _c(
            "q-modal",
            {
              attrs: {
                "content-css": {
                  minWidth: _vm.getMinWidth,
                  maxWidth: _vm.getMaxWidth,
                  minHeight: "80vh"
                }
              },
              on: {
                hide: function($event) {
                  return _vm.clearSelection()
                },
                show: function($event) {
                  return _vm.clearSelection()
                },
                "escape-key": function($event) {
                  return _vm.clearSelection()
                }
              },
              model: {
                value: _vm.show_add_members,
                callback: function($$v) {
                  _vm.show_add_members = $$v
                },
                expression: "show_add_members"
              }
            },
            [
              _c(
                "q-modal-layout",
                [
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "fas fa-times"
                        },
                        on: {
                          click: function($event) {
                            _vm.show_add_members = false
                          }
                        }
                      }),
                      _c("q-toolbar-title", [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.$t("group_members")) +
                            "\n\t\t\t\t"
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "layout-padding" },
                    [
                      _c("q-table", {
                        attrs: {
                          data: _vm.not_members,
                          columns: _vm.columns,
                          pagination: _vm.not_members_server_pagination,
                          filter: _vm.filter_not_members,
                          loading: _vm.loading,
                          selection: "multiple",
                          selected: _vm.selected,
                          "row-key": "id",
                          "no-data-label": _vm.$t(
                            "realize_a_filter_to_show_results"
                          ),
                          "no-results-label": _vm.$t("no_results_found"),
                          "loading-label": _vm.$t("loading_data"),
                          "rows-per-page-label": _vm.$t("items_per_page"),
                          "rows-per-page-options": [5, 10, 50, 100],
                          "binary-state-sort": ""
                        },
                        on: {
                          "update:pagination": function($event) {
                            _vm.not_members_server_pagination = $event
                          },
                          request: _vm.requestNotMembers,
                          "update:selected": function($event) {
                            _vm.selected = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "top",
                              fn: function(props) {
                                return [
                                  _c("div", { staticClass: "col-12" }, [
                                    _c(
                                      "div",
                                      { staticClass: "row gutter-sm" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-12" },
                                          [
                                            _c("q-search", {
                                              attrs: {
                                                icon: "far fa-search",
                                                placeholder: _vm.$t("search"),
                                                "float-label": _vm.$t("search"),
                                                debounce: 500
                                              },
                                              model: {
                                                value: _vm.filter_not_members,
                                                callback: function($$v) {
                                                  _vm.filter_not_members = $$v
                                                },
                                                expression: "filter_not_members"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "col-12" },
                                          [
                                            _c("q-select", {
                                              attrs: {
                                                filter: "",
                                                "autofocus-filter": "",
                                                chips: "",
                                                multiple: "",
                                                options:
                                                  _vm.getOptionsFilter
                                                    .user_areas,
                                                "float-label": _vm.$t(
                                                  "knowledge_area"
                                                )
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.changeAddFilter()
                                                }
                                              },
                                              model: {
                                                value: _vm.area,
                                                callback: function($$v) {
                                                  _vm.area = $$v
                                                },
                                                expression: "area"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "col-12" },
                                          [
                                            _c("q-select", {
                                              attrs: {
                                                filter: "",
                                                "autofocus-filter": "",
                                                chips: "",
                                                multiple: "",
                                                options: _vm.profiles,
                                                "float-label": _vm.$t(
                                                  "profiles"
                                                )
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.changeAddFilter()
                                                }
                                              },
                                              model: {
                                                value: _vm.profile,
                                                callback: function($$v) {
                                                  _vm.profile = $$v
                                                },
                                                expression: "profile"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "col-12" },
                                          [
                                            _c(
                                              "q-chips-input",
                                              {
                                                ref: "companies_label",
                                                attrs: {
                                                  "float-label": _vm.$t(
                                                    "headquarters"
                                                  ),
                                                  debounce: 600,
                                                  clearable: "",
                                                  disable: _vm.loading
                                                },
                                                on: {
                                                  remove: _vm.removeCompany
                                                },
                                                model: {
                                                  value: _vm.companies_label,
                                                  callback: function($$v) {
                                                    _vm.companies_label = $$v
                                                  },
                                                  expression: "companies_label"
                                                }
                                              },
                                              [
                                                _c("q-autocomplete", {
                                                  attrs: {
                                                    "min-characters": 3,
                                                    "max-results": 50
                                                  },
                                                  on: {
                                                    search: _vm.fetchCompanies,
                                                    selected:
                                                      _vm.selectCompanies
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "col-12" },
                                          [
                                            _c(
                                              "q-chips-input",
                                              {
                                                ref: "stores_label",
                                                attrs: {
                                                  "float-label": _vm.$t(
                                                    "branches"
                                                  ),
                                                  debounce: 600,
                                                  clearable: "",
                                                  disable: _vm.loading
                                                },
                                                on: { remove: _vm.removeStore },
                                                model: {
                                                  value: _vm.stores_label,
                                                  callback: function($$v) {
                                                    _vm.stores_label = $$v
                                                  },
                                                  expression: "stores_label"
                                                }
                                              },
                                              [
                                                _c("q-autocomplete", {
                                                  attrs: {
                                                    "min-characters": 3,
                                                    "max-results": 600
                                                  },
                                                  on: {
                                                    search: _vm.fetchStores,
                                                    selected: _vm.selectStores
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 q-mt-md" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "flex justify-end" },
                                          [
                                            _c("q-btn", {
                                              staticClass: "q-mr-md",
                                              attrs: {
                                                color: "primary",
                                                icon: "far fa-cloud-upload",
                                                label: _vm.$t("import")
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.show_add_members_import = true
                                                }
                                              }
                                            }),
                                            _c("q-btn", {
                                              staticClass: "q-mr-md",
                                              attrs: {
                                                color: "positive",
                                                icon: "far fa-save",
                                                label: _vm.$t("add_members"),
                                                disable:
                                                  _vm.selected.length > 0
                                                    ? false
                                                    : true
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.addSelectedMembers()
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              }
                            },
                            {
                              key: "header",
                              fn: function(props) {
                                return _c(
                                  "q-tr",
                                  { attrs: { props: props } },
                                  [
                                    _c(
                                      "q-th",
                                      { attrs: { "auto-width": "" } },
                                      [
                                        _c("q-checkbox", {
                                          attrs: {
                                            "indeterminate-value": "some"
                                          },
                                          model: {
                                            value: props.selected,
                                            callback: function($$v) {
                                              _vm.$set(props, "selected", $$v)
                                            },
                                            expression: "props.selected"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._l(props.cols, function(col) {
                                      return _c(
                                        "q-th",
                                        {
                                          key: col.name,
                                          attrs: { props: props }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.$t(col.label)) +
                                              "\n\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              }
                            },
                            {
                              key: "body",
                              fn: function(props) {
                                return _c(
                                  "q-tr",
                                  { attrs: { props: props } },
                                  [
                                    _c(
                                      "q-td",
                                      { attrs: { "auto-width": "" } },
                                      [
                                        _c("q-checkbox", {
                                          attrs: { color: "primary" },
                                          model: {
                                            value: props.selected,
                                            callback: function($$v) {
                                              _vm.$set(props, "selected", $$v)
                                            },
                                            expression: "props.selected"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "q-td",
                                      { key: "id", attrs: { props: props } },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(props.row.id) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      { key: "email", attrs: { props: props } },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(props.row.email) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "full_name",
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(props.row.full_name) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "document",
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(props.row.document) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "branches",
                                        attrs: { props: props }
                                      },
                                      [
                                        _c(
                                          "q-btn",
                                          {
                                            attrs: {
                                              color: "primary",
                                              "text-color": "white",
                                              label: _vm.getQuantityBranches(
                                                props.row.branches
                                              ),
                                              "no-ripple": ""
                                            }
                                          },
                                          [
                                            props.row.branches.length > 0
                                              ? _c("q-tooltip", [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "tooltip q-mb-sm"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.$t("branch")
                                                          ) +
                                                          ":\n\t\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                      _vm._l(
                                                        props.row.branches,
                                                        function(
                                                          branch,
                                                          index
                                                        ) {
                                                          return _c(
                                                            "span",
                                                            { key: index },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    branch
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                              ),
                                                              props.row.branches
                                                                .length -
                                                                1 >
                                                              index
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      ",\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                    )
                                                                  ])
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ])
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "companies",
                                        attrs: { props: props }
                                      },
                                      [
                                        _c(
                                          "q-btn",
                                          {
                                            attrs: {
                                              color: "primary",
                                              "text-color": "white",
                                              label: _vm.getQuantityCompanies(
                                                props.row.companies
                                              ),
                                              "no-ripple": ""
                                            }
                                          },
                                          [
                                            props.row.companies.length > 0
                                              ? _c("q-tooltip", [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "tooltip q-mb-sm"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.$t("company")
                                                          ) +
                                                          ":\n\t\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                      _vm._l(
                                                        props.row.companies,
                                                        function(
                                                          company,
                                                          index
                                                        ) {
                                                          return _c(
                                                            "span",
                                                            { key: index },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    company
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                              ),
                                                              props.row
                                                                .companies
                                                                .length -
                                                                1 >
                                                              index
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      ",\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                    )
                                                                  ])
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ])
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "profile",
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.getProfile(props.row.profile)
                                            ) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }
                            }
                          ],
                          null,
                          false,
                          1673104469
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          on: {
            hide: function($event) {
              return _vm.clearSelection()
            },
            show: function($event) {
              return _vm.clearSelection()
            },
            "escape-key": function($event) {
              return _vm.clearSelection()
            }
          },
          model: {
            value: _vm.show_add_members_import,
            callback: function($$v) {
              _vm.show_add_members_import = $$v
            },
            expression: "show_add_members_import"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.closeImport()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("import")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "row gutter-sm" }, [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-6" },
                        [
                          _c("p", { staticClass: "caption" }, [
                            _vm._v(_vm._s(_vm.$t("file")))
                          ]),
                          _c("uploader", {
                            attrs: { content_type: "", multiple: false },
                            on: { fileUploaded: _vm.fileUploaded }
                          }),
                          _vm.file_url
                            ? _c(
                                "p",
                                { staticClass: "q-mt-md file-url" },
                                [
                                  _c("q-icon", {
                                    attrs: {
                                      name: "fal fa-check",
                                      color: "positive"
                                    }
                                  }),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.file_url,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$truncateLink(_vm.file_url)
                                          )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _c("div", { staticClass: "row gutter-sm q-mt-lg" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("h4", { staticClass: "q-my-md" }, [
                        _vm._v(_vm._s(_vm.$t("logs")))
                      ]),
                      _c("q-table", {
                        attrs: {
                          data: _vm.users_import,
                          columns: _vm.columns_logs,
                          filter: _vm.filter,
                          "row-key": "line"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function(props) {
                              return _c(
                                "q-tr",
                                { attrs: { props: props } },
                                _vm._l(props.cols, function(col) {
                                  return _c(
                                    "q-th",
                                    { key: col.name, attrs: { props: props } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.$t(col.label)) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            }
                          },
                          {
                            key: "body",
                            fn: function(props) {
                              return _c(
                                "q-tr",
                                {
                                  class:
                                    props.row.exists === false
                                      ? "bg-red-1"
                                      : "",
                                  attrs: { props: props }
                                },
                                [
                                  _c(
                                    "q-td",
                                    { key: "id", attrs: { props: props } },
                                    [_vm._v(_vm._s(props.row.id))]
                                  ),
                                  _c(
                                    "q-td",
                                    { key: "email", attrs: { props: props } },
                                    [_vm._v(_vm._s(props.row.email))]
                                  ),
                                  _c(
                                    "q-td",
                                    { key: "exists", attrs: { props: props } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          props.row.exists == false
                                            ? _vm.$t(
                                                "user_not_found_or_incorrect"
                                              )
                                            : ""
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("save")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "primary",
                            label: _vm.$t("import_test_template"),
                            icon: "far fa-file-spreadsheet"
                          },
                          on: {
                            click: function($event) {
                              return _vm.generateTemplate()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("import")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "green",
                            label: _vm.$t("import"),
                            icon: "far fa-check"
                          },
                          on: {
                            click: function($event) {
                              return _vm.importUsers()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeMembers },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeMembers()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }